import { migrateBoatDocument } from './migrate.ts';
import type { BoatDocument } from './types.ts';
import { CURRENT_BOAT_VERSION } from './version.ts';

export function serializeBoat(boat: BoatDocument): string {
  return JSON.stringify({ ...boat, version: CURRENT_BOAT_VERSION });
}

/** Returns null instead of throwing. The returned document is always the current version. */
export function parseBoatDocument(json: string): BoatDocument | null {
  try {
    return migrateBoatDocument(JSON.parse(json) as unknown);
  } catch {
    return null;
  }
}

export function isBoatDocument(value: unknown): boolean {
  return migrateBoatDocument(value) !== null;
}

export function cloneBoatDocument(boat: BoatDocument): BoatDocument {
  if (typeof structuredClone === 'function') {
    return structuredClone(boat);
  }

  return JSON.parse(JSON.stringify(boat)) as BoatDocument;
}
